import angular from 'angular';

export default function adjustToHorizontalScroll($window) {
  'ngInject';

  return {
    restrict: 'A',
    link($scope, $element, $attrs) {
      let arbitraryOffset = 0;
      const options = $scope.$eval($attrs.adjustToHorizontalScroll);
      if (options && options.offset) {
        arbitraryOffset = options.offset;
      }

      function handler() {
        const offset = $window.scrollX || $window.pageXOffset || 0;
        if (offset === 0) {
          $element.css({
            '-webkit-transform': '',
            transform: '',
          });
        } else {
          $element.css({
            '-webkit-transform': `translateX(${-offset + arbitraryOffset}px)`,
            transform: `translateX(${-offset + arbitraryOffset}px)`,
          });
        }
      }

      angular.element($window).on('scroll', handler);
      $scope.$on('$destroy', () => {
        angular.element($window).off('scroll', handler);
      });
    },
  };
}
